import { Mail, MessageCircle } from "lucide-react";
import { useLang, WHATSAPP_URL, EMAIL, EMAIL_URL } from "../i18n";
import { trackEvent } from "../lib";
import { Reveal, Section } from "./Reveal";

export const Cta = () => {
  const { t } = useLang();

  return (
    <Section id="contato" className="overflow-hidden">
      <div className="pointer-events-none absolute -top-40 left-1/2 h-[480px] w-[820px] -translate-x-1/2 rounded-full bg-volt/10 blur-[120px]" />
      <div className="relative">
        <Reveal>
          <p className="font-mono text-xs font-semibold uppercase tracking-[0.3em] text-volt">
            {t.cta.label}
          </p>
        </Reveal>
        <Reveal delay={0.08}>
          <h2 className="mt-5 max-w-3xl font-display text-4xl font-black leading-[1.02] tracking-tighter sm:text-6xl md:text-7xl">
            {t.cta.heading}
          </h2>
        </Reveal>
        <Reveal delay={0.16}>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-mist sm:text-lg">{t.cta.sub}</p>
        </Reveal>
        <Reveal delay={0.24}>
          <div className="mt-10 flex flex-wrap items-center gap-4">
            <a
              data-testid="cta-whatsapp"
              href={WHATSAPP_URL}
              target="_blank"
              rel="noreferrer"
              onClick={() => trackEvent("whatsapp_click", { section: "contato" })}
              className="inline-flex items-center gap-2.5 rounded-full bg-volt px-8 py-4 font-display font-bold text-black transition-shadow hover:shadow-[0_0_50px_-8px_rgba(0,229,255,0.85)]"
            >
              <MessageCircle size={20} />
              {t.cta.wpp}
            </a>
            <a
              data-testid="cta-email"
              href={EMAIL_URL}
              onClick={() => trackEvent("email_click", { section: "contato" })}
              className="inline-flex items-center gap-2.5 rounded-full border border-white/25 px-8 py-4 font-mono text-sm text-white/85 transition-colors hover:bg-white hover:text-black"
            >
              <Mail size={18} />
              {t.cta.email}
            </a>
          </div>
        </Reveal>
        <Reveal delay={0.3}>
          <p className="mt-10 font-mono text-[11px] uppercase tracking-[0.25em] text-white/35">
            {t.cta.note}
          </p>
        </Reveal>
      </div>
    </Section>
  );
};
